<header class="list-page-header">
	<div class="list-page-header__title">
		@if (icon(); as pageIcon) {
			<app-icon [icon]="pageIcon" iconSize="small" />
		}
		<h1 class="list-page-header__title-text">{{ title() }}</h1>
	</div>
	@if (resultsLabel()) {
		<span class="list-page-header__results">{{ resultsLabel() }}</span>
	}
</header>
